import { FC } from 'react';

import { TableComponent } from 'components/TableComponent';

import { TableRowProps } from './SelectProjectTableContent';

import classes from './selectProjectPage.module.css';

export const TableRow: FC<TableRowProps> = ({
  children,
}) => {
  return (
    <TableComponent.TableRow className={classes.tableRow}>
      <TableComponent.TableCell className={classes.tableCell}>
        {children}
      </TableComponent.TableCell>
    </TableComponent.TableRow>
  );
};
